import { Input, Textarea } from '@chakra-ui/react';
import FocusFormField from '@components/focus/focus-form-field.component';
import ColorPicker from '@components/general/colorpicker.component.jsx';

export default function FocusEditDetails({
  title,
  setTitle,
  description,
  setDescription,
  color,
  setColor,
  onBlur,
  children
}) {
  return (
    <>
      <FocusFormField label='Category'>
        <Input
          placeholder='Category'
          size='lg'
          value={title}
          onChange={(e) => setTitle(e?.target?.value)}
          onBlur={onBlur}
        />
      </FocusFormField>
      <FocusFormField label='Description'>
        <Textarea
          rows='5'
          borderRadius='xl'
          bgColor='white'
          placeholder='Add context to help FORA understand this category. How is information shared (meetings, chats, reports)? What are the main subjects covered within this category?'
          value={description}
          onChange={(e) => setDescription(e?.target?.value)}
          onBlur={onBlur}
        />
      </FocusFormField>

      <FocusFormField label='Color'>
        <ColorPicker
          color={color}
          setColor={setColor}
          onClose={onBlur}
        />
      </FocusFormField>
      {children}
    </>
  );
}
